import React from "react";

import { CProgress } from "@coreui/react";

import Charts from "../../Charts";
import "./styles.scss";

const AcertosPorAssunto = ({ applications, list }) => {
  const getAbilityPercentage = abilityId => {
    const questions = list.questions
      .filter(question => question.ability_id === abilityId)
      .map(question => question.id);

    let total = questions.length * applications.length;
    let correct = 0;

    questions.forEach(question => {
      applications.forEach(application => {
        if (
          application.answers.find(answer => answer.question_id === question)
            ?.correct
        ) {
          correct++;
        }
      });
    });

    return (correct / total) * 100;
  };

  const getAbilityQuantity = abilityId => {
    const questions = list.questions
      .filter(question => question.ability_id === abilityId)
      .map(question => question.id);

    let correct = 0;

    questions.forEach(question => {
      applications.forEach(application => {
        if (
          application.answers.find(answer => answer.question_id === question)
            ?.correct
        ) {
          correct++;
        }
      });
    });

    return correct;
  };

  const abilities =
    list.questions?.filter(
      (question, index) =>
        index ===
        list.questions.findIndex(
          indexQuestion => indexQuestion.ability_id === question.ability_id
        )
    ) || [];

  return (
    <>
      <div className="management-1statistics mb-5">
        <div className="row">
          <div className="chart">
            <Charts
              legendY="Assuntos"
              legendX="Acertos %"
              type="horizontalbar"
              title=""
              data={{
                labels: abilities.map(
                  ability => ability.ability_description || "(Sem habilidade)"
                ),
                datasets: [
                  {
                    data: [
                      ...abilities.map(ability =>
                        getAbilityPercentage(ability.ability_id).toFixed(0)
                      ),
                      100
                    ],
                    backgroundColor: [
                      "rgba(255, 99, 132, 0.2)",
                      "rgba(54, 162, 235, 0.2)",
                      "rgba(255, 206, 86, 0.2)",
                      "rgba(75, 192, 192, 0.2)",
                      "rgba(153, 102, 255, 0.2)",
                      "rgba(255, 159, 64, 0.2)",
                      "rgba(255, 0, 41, 0.2)",
                      "rgba(55, 126, 184, 0.2)",
                      "rgba(102, 166, 30, 0.2)",
                      "rgba(152, 78, 163, 0.2)",
                      "rgba(0, 210, 213, 0.2)",
                      "rgba(255, 127, 0, 0.2)",
                      "rgba(254, 224, 182, 0.2)",
                      "rgba(127, 128, 205, 0.2)",
                      "rgba(179, 233, 0, 0.2)",
                      "rgba(196, 46, 96, 0.2)"
                    ],
                    borderColor: [
                      "rgba(255, 99, 132, 1)",
                      "rgba(54, 162, 235, 1)",
                      "rgba(255, 206, 86, 1)",
                      "rgba(75, 192, 192, 1)",
                      "rgba(153, 102, 255, 1)",
                      "rgba(255, 159, 64, 1)",
                      "rgba(255, 0, 41, 1)",
                      "rgba(55, 126, 184, 1)",
                      "rgba(102, 166, 30, 1)",
                      "rgba(152, 78, 163, 1)",
                      "rgba(0, 210, 213, 1)",
                      "rgba(255, 127, 0, 1)",
                      "rgba(254, 224, 182, 1)",
                      "rgba(127, 128, 205, 1)",
                      "rgba(179, 233, 0, 1)",
                      "rgba(196, 46, 96, 1)"
                    ],
                    borderWidth: 1
                  }
                ]
              }}
            />
          </div>
        </div>
      </div>

      <div className="">
        <table className="table table-hover table-outline mb-0 d-none d-sm-table acertosPorAssunto">
          <thead className="thead-light">
            <tr>
              <th>Assunto</th>
              <th>Acertos</th>
              <th>% Acertos</th>
            </tr>
          </thead>
          <tbody>
            {abilities.map(ability => (
              <tr>
                <td>{ability.ability_description || "(Sem habilidade)"}</td>
                <td>{getAbilityQuantity(ability.ability_id) || ""}</td>
                <td>
                  <div className="clearfix">
                    <div className="float-left">
                      {getAbilityPercentage(ability.ability_id).toFixed(0)}%
                    </div>
                  </div>
                  <CProgress
                    className="progress-xs"
                    color={
                      getAbilityPercentage(ability.ability_id).toFixed(0) > 50
                        ? "success"
                        : getAbilityPercentage(ability.ability_id).toFixed(0) <=
                            50 &&
                          getAbilityPercentage(ability.ability_id).toFixed(0) >=
                            30
                        ? "warning"
                        : "danger"
                    }
                    value={getAbilityPercentage(ability.ability_id).toFixed(0)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AcertosPorAssunto;
